import { CurrentLendersState } from './CurrentLenderTypes';
import { CurrentLender } from '../../../types';

export const LOAD_CURRENT_LENDERS_ERR = 'loadCurrentLenderErr';
export const LOADING_CURRENT_LENDERS = 'loadingCurrentLenders';
export const LOAD_CURRENT_LENDERS_OK = 'loadCurrentLenderSuccess';
export const EDIT_CURRENT_LENDER = 'editCurrentLender';
export const CREATE_CURRENT_LENDER = 'createCurrentLender';
export const SUBMIT_CURRENT_LENDER = 'submitCurrentLender';
export const CANCEL_CURRENT_LENDER_FORM = 'cancelCurrentLender';

export const emptyLender: CurrentLender = {
  CurrentLenderId: 0,
  LenderName: '',
  Active: false,
  SiteVertical: '',
  DisplayOrder: 0,
};

export const CURRENT_LENDERS: CurrentLendersState = {
  loadState: 0,
  lenders: [],
  form: {
    enabled: false,
    data: { ...emptyLender },
  },
};
